
import { ReservierungNeu } from "mangdto"
import Component, { mixins } from "vue-class-component"
import { Emit, Prop } from "vue-property-decorator"
import Calculator from "../mixins/Calculator.vue"

@Component
export default class ReservierungRow extends mixins(Calculator) {
  @Prop() reservierung: ReservierungNeu

  bestimmeZeitraum(): string {
    return this.formatiereTimeSpan(
      this.reservierung.zeitVon,
      this.reservierung.zeitBis,
    )
  }

  @Emit("detailsAnzeigen")
  detailsAnzeigen() {}
}
